import { render, staticRenderFns } from "./MealSelector.vue?vue&type=template&id=a3c801ce&"
import script from "./MealSelector.vue?vue&type=script&lang=js&"
export * from "./MealSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports